import utils from "../utils";

const observer = {
	elems: {
		video: document.querySelectorAll("[data-video]"),
		anim: document.querySelectorAll(".is-animated"),
	},
	obj: {
		video: null,
		lazy: null,
		anim: null,
	},
	set: {
		video: function () {
			observer.obj.video = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						let video = entry.target;
						if (video.hasAttribute("data-src")) {
							video.src = video.getAttribute("data-src");
							video.addEventListener("canplaythrough", function () {
								video.style.opacity = 1;
								video.addEventListener("transitionend", function () {
									let parent = video.parentElement,
										thumb = parent.querySelector(".thumb-video");

									if(thumb){
										parent.removeChild(thumb);
									}
								});
							});
							video.load();
							video.removeAttribute("data-src");
							video.setAttribute("data-running", "true");
						} else {
							if (video.getAttribute("data-running") === "false") {
								video.play();
								video.setAttribute("data-running", "true");
							}
						}
					} else {
						let video = entry.target;
						if (video.getAttribute("data-running") === "true") {
							video.pause();
							video.setAttribute("data-running", "false");
						}
					}
				});
			});
		},
		anim: function () {
			observer.obj.anim = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting || entry.intersectionRatio > 0) {
							let inViewEl = entry.target;
							inViewEl.classList.add("in-view");
							observer.obj.anim.unobserve(inViewEl);
						}
					});
				},
				{
					rootMargin: "10% 0px 10% 0px",
					threshold: 0.1,
				}
			);
		},
	},
	start: function (elems, type) {
		if (elems.length > 0) {
			if (utils.observerReady) {
				observer.set[type]();
				utils.forEach(elems, function (index, elem) {
					observer.obj[type].observe(elem);
				});
				if (type === "video") {
					document.addEventListener("visibilitychange", function () {
						if (document.visibilityState === "visible") {
							let pausedVideo = document.querySelectorAll("video[data-paused]");
							if (pausedVideo.length > 0) {
								utils.forEach(pausedVideo, function (index, video) {
									video.play();
								});
							}
						} else {
							let playingVideo = document.querySelectorAll(
								"[data-running='true']"
							);
							if (playingVideo.length > 0) {
								utils.forEach(playingVideo, function (index, video) {
									video.setAttribute("data-paused", "");
									video.pause();
								});
							}
						}
					});
				}
			} else {
				utils.forEach(elems, function (index, elem) {
					if (type !== "video") {
						elem.classList.add("in-view");
					} else {
						elem.src = elem.getAttribute("data-src");
						elem.style.opacity = 1;
					}
				});
			}
		}
	},
	init: function () {
		observer.start(observer.elems.video, "video");
		observer.start(observer.elems.anim, "anim");
	},
};

export default observer;